@if (question && formGroup) {
<div class="question-container">
  <form [formGroup]="formGroup">
    @switch (question.type) {
    <!--  -->
    @case (FeedbackQuestionType.TEXT){
    <!-- text question -->
    <div>
      <textarea
        motifInput
        formControlName="textInput"
        class="answer-textarea"
        [attr.placeholder]="question.input_box_default_text"
      ></textarea>
    </div>

    }
    <!--  -->
    @case (FeedbackQuestionType.CHOICE){
    <!-- choice question -->
    <p class="question-label">Please select the option that applies</p>

    @if(optionFormGroups){
    <!--  -->
    @for (option of question.options; let i = $index; track $index) {
    <div #optionContainer class="option-container" [style.--label-color]="option.label_color">
      <div class="option-row" [formGroup]="optionFormGroups[i]">
        <motif-checkbox
          #optionCheckbox
          [checked]="optionFormGroups[i]?.get('optionChecked')?.value"
          [attr.aria-label]="option.label ? option.label + ': ' + option.text : option.text"
          (valueChange)="onOptionCheckboxChange(i, $event)"
        ></motif-checkbox>
        <p class="option-text">
          <span *ngIf="option.label" class="option-label-prefix">{{ option.label }}:</span>
          {{ option.text }}
        </p>
      </div>

      @if (option.text_input_type != FeedbackTextType.NONE){
      <div class="option-text-input-container" [formGroup]="optionFormGroups[i]">
        <textarea
          motifInput
          formControlName="textInput"
          class="answer-textarea"
          [attr.placeholder]="option.input_box_default_text"
        ></textarea>
      </div>
      }
    </div>
    }
    <!-- END @for question.options  -->
    }
    <!-- END @if optionFormGroups -->
    }
    <!-- END @case FeedbackQuestionType.CHOICE -->

    @case (FeedbackQuestionType.CHOICE_AND_TEXT) {
    <!-- TODO choice and text question -->

    }
    <!-- END @case FeedbackQuestionType.CHOICE_AND_TEXT  -->
    }
  </form>
</div>
}
